// https://docs.sentry.io/platforms/javascript/guides/nuxt/manual-setup/
// https://docs.sentry.io/platforms/javascript/guides/nuxt/features/pinia/

import * as Sentry from "@sentry/nuxt"

const runtimeConfig = useRuntimeConfig()

if (runtimeConfig.public.sentry.enable) {
  Sentry.init({
    dsn: runtimeConfig.public.sentry.dsn,
    environment:
      process.env.NUXT_PUBLIC_APP_ENVIRONMENT ||
      runtimeConfig.public.appEnvironment,
    integrations: [Sentry.piniaIntegration(usePinia())],
    normalizeDepth: 10,
    tracePropagationTargets: [
      /^https:\/\/www\.unitcrunch\.com/,
      // /^https:\/\/.*--unitcrunch\.netlify\.app/,
      // /^http:\/\/localhost:3000/,
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
  Sentry.setTag("app.version", runtimeConfig.public.clientVersion)
}
